// extracted by css-extract-rspack-plugin
export default {"handleTrack":"SidebarResizeHandle-module__handleTrack__roHKs"};